<template lang="pug">
div
  l-control(position="topright")
    .d-flex.settings-map
      div.splank(v-if="settingsMap.showMenu")
        b-button-group
          b-button#popover-create-gsm(v-if="$route.name !== 'locator'", v-b-tooltip.hover.bottom, variant="light", @click="showGsm", title="Проблемы GSM", :pressed="showGsmOpen").px-1.py-1
            b-icon(icon="wifi", :variant="showGsmOpen ? 'info' : 'secondary'", font-scale="1")
          b-button#popover-create-gps(v-if="$route.name !== 'locator'", v-b-tooltip.hover.bottom, variant="light", @click="showGps", title="Проблемы GPS", :pressed="showGpsOpen").px-1.py-1
            b-icon(icon="broadcast-pin", :variant="showGpsOpen ? 'info' : 'secondary'", font-scale="1")
          b-button#popover-map(variant="light", @mouseenter="settings.map = true", @mouseleave="settings.map = false").px-1.py-1
            b-icon(icon="layers-fill", :variant="settings.map ? 'info' : 'secondary'", font-scale="1")
          b-popover(
            target="popover-map",
            triggers="hover",
            placement="bottom",
            @show="settings.map = true",
            @hide="settings.map = false")
            b-dropdown.dropdown-au-map.mb-2(
              v-if="$store.state.user.data.isAdmin",
              size='sm',
              variant='outline-secondary',
              left,
              menu-class="dropdown-tag--container",
              boundary="window")
              template(#button-content)
                | {{ nameAUMap }}
              b-dropdown-group
                b-dropdown-form
                  b-form-group.mb-0(
                    @submit.stop.prevent
                    label-for='search-au-input',
                    label='Поиск',
                    label-cols-md='auto',
                    label-size='sm')
                    b-form-input#search-au-input(
                      v-model='searchAU',
                      type='search',
                      size='sm',
                      autocomplete='off')
              b-dropdown-divider
              b-dropdown-group.select-au-map.ddOl
                b-dropdown-item-button(
                  v-for='AU in availableAU',
                  :key='AU.Id',
                  @click='chooseAUMap(AU)')
                  | {{ AU.Name }}
                b-dropdown-text(v-if='!availableAU.length')
                  | По заданному критерию ничего нет
            div.base-layers-map
              b-form-group(label="Источник карты")
                b-form-radio-group(v-model="selectedMap", :options="layers", name="radio-options", plain, stacked, size="sm")
          b-button(v-b-tooltip.hover.bottom, variant="light", @click="setPreference({ overViewMapState: !settingsMap.overViewMapState })", title="Мини карта").px-1.py-1
            b-icon(icon="globe2", :variant="settingsMap.overViewMapState ? 'info' : 'secondary'", font-scale="1")
          b-button(v-b-tooltip.hover.bottom, variant="light", @click="setNoActivePreference({ showAreaDraw: !settingsMap.showAreaDraw, showRulerDraw: false })", title="Площадь").px-1.py-1
            b-icon(icon="pentagon-fill", :variant="settingsMap.showAreaDraw ? 'info' : 'secondary'", font-scale="1")
          b-button(v-b-tooltip.hover.bottom, variant="light", @click="setNoActivePreference({ showRulerDraw: !settingsMap.showRulerDraw, showAreaDraw: false })", title="Линейка").px-1.py-1
            b-icon(icon="share-fill", :variant="settingsMap.showRulerDraw ? 'info' : 'secondary'", font-scale="1")
          b-button#popover-create-route(v-b-tooltip.hover.bottom, variant="light", @click="showRoute", :pressed="showRouteOpen", title="Прокладка маршрута").px-1.py-1
            b-icon(icon="geo-alt-fill", :variant="showRouteOpen ? 'info' : 'secondary'", font-scale="1")
          b-button(v-b-tooltip.hover.bottom, variant="light", @click="setPreference({ needFootprints: !settingsMap.needFootprints})", title="Следы объекта").px-1.py-1
            b-icon(icon="capslock-fill", :variant="settingsMap.needFootprints ? 'info' : 'secondary'", font-scale="1")
          b-button(v-b-tooltip.hover.bottom, variant="light", @click="setPreference({ showObjectDirection: !settingsMap.showObjectDirection })", title="Направление объекта").px-1.py-1
            b-icon(icon="compass", :variant="settingsMap.showObjectDirection ? 'info' : 'secondary'", font-scale="1")
          b-button(v-b-tooltip.hover.bottom, variant="light", @click="setPreference({ showObjectName: !settingsMap.showObjectName })", title="Показать имя объекта").px-1.py-1
            b-icon(icon="pencil-square", :variant="settingsMap.showObjectName ? 'info' : 'secondary'", font-scale="1")
          b-button(v-b-tooltip.hover.bottom, variant="light", @click="changeGrouping", title="Группировка объектов").px-2.py-1
            b-icon(icon="union", :variant="grouping ? 'info' : 'secondary'", font-scale="1")
      b-button(v-b-tooltip.hover.bottom, variant="light", @click="setPreference({ showMenu: !settingsMap.showMenu })", title="Инструменты карты" style="border: 2px solid rgba(0,0,0,0.2);").px-1.py-1
        b-icon(icon="gear-fill", :variant="settingsMap.showMenu ? 'info' : 'secondary'", font-scale="1")
  l-layer-group(v-if="activeItem")
    le-marker(:item="activeItem", :key="activeItem.id", active)
  group(v-if="resolveAddMarkers && showClusters", :is="groupComponent", :options="options.cluster", ref="cluster")
    le-marker(v-for="item in withoutActive", :key="item.id", @click="selectObject(item.id)", :item="item")
  l-feature-group(ref="popup")
    l-popup.mapobj-popup--body(:options="options.popup", @mouseover.native="popmouseover", @mouseout.native="popmouseout")
      .w-100.d-flex.justify-content-center.m-2(v-if="popupCluster.length === 0")
        b-spinner(small, type="grow", variant="info")
      .w-100.d-flex
        b-list-group(flush).w-100
          b-list-group-item(v-for="item in popupCluster", :key="item.id",
            button, :title="item.data.Name", :active="false", @click="selectObject(item.id)") {{ item.data.Name }}
  b-popover(target="popover-create-gsm", triggers="click", placement="bottomright", custom-class="popover-panel ml-3", :delay="{ hide: 600, show: 0 }", no-fade, :show="showGsmOpen")
    template(v-slot:title)
      | Проблемы GSM
      a.close(href="#", @click="showGsmOpen = false")
        b-icon.h3(icon="x")
    .popover-wrapper.popover-body
      .justify-content-between.px-2
        span Период:
        .d-flex.align-items-center
          b-input-group.mb-3
            b-form-datepicker(v-model='gsm.from', block, :max='gsm.to', start-weekday="1", locale="ru-RU", style="width: 230px; font-size: 14px;", title="от")
            b-form-input#time-from-gsm-from(v-model='gsm.timeFrom', readonly,  type="text", min="00:00:00", max="23:59:59", placeholder='ЧЧ:мм:cc', :style="{height: 'auto', 'font-size': '14px'}")
            b-input-group-append
              b-form-timepicker(v-model='gsm.timeFrom', v-bind="ruLocale", button-only, right, show-seconds, locale='ru', aria-controls='time-from-input')
        .d-flex.align-items-center
          b-input-group.mb-3
            b-form-datepicker(v-model='gsm.to', block, :min='gsm.from', :max='new Date()', , start-weekday="1", locale="ru-RU", style="width: 230px; font-size: 14px;", title="до")
            b-form-input#time-from-gsm-to(v-model='gsm.timeTo', readonly,  type="text", min="00:00:00", max="23:59:59", placeholder='ЧЧ:мм:cc', :style="{height: 'auto', 'font-size': '14px'}")
            b-input-group-append
            b-form-timepicker(v-model='gsm.timeFrom', v-bind="ruLocale", button-only, right, show-seconds, locale='ru', aria-controls='time-from-input')
      .justify-content-between.px-2
        span Время досылки сообщения (секунд):
        .d-flex.align-items-center
          b-form-input.mr-2(v-model='gsm.timeSendFrom', type="number", min="1", :max="gsm.timeSendTo", title="от")
          b-form-input(v-model='gsm.timeSendTo', type="number", :min="gsm.timeSendFrom", title="до")
      .d-flex.p-2.align-items-center.justify-content-between
        span Только объекты из панели мониторинга:
        b-form-checkbox(v-model='gsm.monitoringOnly')
        b-dropdown(v-if="!gsm.monitoringOnly && $store.state.user.data ? $store.state.user.data.isAdmin  : false" boundary="window" no-flip menu-class="ddOl outmax" :text="nameAU(gsm.accountingUnitId)", title="Выбор учетной единицы" v-b-tooltip.hover variant="light")
          b-dropdown-item-button(v-for="dItem in accountingUnits" :key="dItem.Id"
          @click="gsm.accountingUnitId = dItem.Id;" :active="dItem.Id === gsm.accountingUnitId") {{ dItem.Name }}
      .d-flex.align-items-center.justify-content-between.px-2
        p Радиус точки:
        b-form-input(v-model="gsm.radius", type="range", min="1", max="50", step="1", style="width: 250px;")
      .d-flex.align-items-center.justify-content-between.p-2
        p Размытость:
        b-form-input(v-model="gsm.blur", type="range", min="1", max="50", step="1", style="width: 250px;")
      .p-2
        b-button#popover-create-gsm(variant="success", @click="getGSM(gsm)", block).px-1.py-1 OK
  b-popover(target="popover-create-gps", triggers="click", placement="bottomright", custom-class="popover-panel ml-3", :delay="{ hide: 600, show: 0 }", no-fade, :show.sync="showGpsOpen")
    template(v-slot:title)
      | Проблемы GPS
      a.close(href="#", @click="showGpsOpen = false")
        b-icon.h3(icon="x")
    .popover-wrapper.popover-body
      .justify-content-between.px-2
        span Период:
        .d-flex.align-items-center
          b-input-group.mb-3
            b-form-datepicker(v-model='gps.from', block, :max='gps.to', start-weekday="1", locale="ru-RU", style="width: 230px; font-size: 14px;", title="от")
            b-form-input#time-from-gps-from(v-model='gps.timeFrom', readonly,  type="text", min="00:00:00", max="23:59:59", placeholder='ЧЧ:мм:cc', :style="{height: 'auto', 'font-size': '14px'}")
            b-input-group-append
              b-form-timepicker(v-model='gps.timeFrom', v-bind="ruLocale", button-only, right, show-seconds, locale='ru', aria-controls='time-from-input')
        .d-flex.align-items-center
          b-input-group.mb-3
            b-form-datepicker(v-model='gps.to', block, :min='gps.from', :max='new Date()', , start-weekday="1", locale="ru-RU", style="width: 230px; font-size: 14px;", title="до")
            b-form-input#time-from-gps-to(v-model='gps.timeTo', readonly,  type="text", min="00:00:00", max="23:59:59", placeholder='ЧЧ:мм:cc', :style="{height: 'auto', 'font-size': '14px'}")
            b-input-group-append
            b-form-timepicker(v-model='gps.timeFrom', v-bind="ruLocale", button-only, right, show-seconds, locale='ru', aria-controls='time-from-input')
      .justify-content-between.px-2
        span Минимальное количество спутников:
        b-form-input(v-model='gps.minSatellites', type="number", min="0")
      .d-flex.align-items-center.justify-content-between.p-2
        span Только объекты из панели мониторинга:
        b-form-checkbox(v-model='gps.monitoringOnly')
        b-dropdown(v-if="!gps.monitoringOnly && $store.state.user.data ? $store.state.user.data.isAdmin  : false" boundary="window" no-flip menu-class="ddOl outmax" :text="nameAU(gps.accountingUnitId)", title="Выбор учетной единицы" v-b-tooltip.hover variant="light")
          b-dropdown-item-button(v-for="dItem in accountingUnits" :key="dItem.Id"
          @click="gps.accountingUnitId = dItem.Id;" :active="dItem.Id === gps.accountingUnitId") {{ dItem.Name }}
      .d-flex.align-items-center.justify-content-between.px-2
        p Радиус точки:
        b-form-input(v-model="gps.radius", type="range", min="1", max="50", step="1", style="width: 250px;")
      .d-flex.align-items-center.justify-content-between.p-2
        p Размытость:
        b-form-input(v-model="gps.blur", type="range", min="1", max="50", step="1", style="width: 250px;")
      .p-2
        b-button#popover-create-gps(variant="success", @click="getGPS(gps)", block).px-1.py-1 OK
  b-popover(target="popover-create-route",
    triggers="click",
    placement="bottomright",
    custom-class="popover-panel ml-3",
    :delay="{ hide: 600, show: 0 }",
    no-fade,
    :show.sync="showRouteOpen",
    @hidden="restartSendObjectAlongRoute")
    template(v-slot:title)
      | Построить трек
      a.close(href="#", @click="showRouteOpen = false")
        b-icon.h3(icon="x")
    draggable.mb-2(
      :list="points",
      ghost-class="ghost",
      handle=".handle",
      @change="checkMove",
      @start="dragging = true",
      @end="dragging = false",
      style="max-height: calc(100vh - 350px); overflow: auto")
      b-input-group(v-for="(point, index) in points",
        :key="point.id",
        class="list-group-item-field",
        style="padding: 6px 12px")
        b-input-group-prepend
          div.input-group-text.handle(
            @mousedown="checkMouseDown($event)",
            @mouseUp="checkMouseUp($event)",
            @mouseover="checkMouseOver($event)",
            @click="checkMouseClick($event)",
            style="cursor: grab; padding: 2px 12px") {{ String(index + 1) }}
        b-form-input(
          v-model="point.address",
          readonly,
          type="text",
          placeholder='Выберите точку на карте',
          size="sm", :style="{'min-width': '278px', 'font-size': '14px'}")
        b-input-group-append(v-if="points.length > 2")
          b-button(
            @click="removePoint(point.id, index)",
            variant="danger",
            size="sm", style="font-weight: 800;") —
    .d-flex.justify-content-between.px-3.mb-2
      div
        b-button.mr-2(@click="addPoint", variant="success", size="sm", style="font-weight: 800;") +
        b-button(
          @click="showImportURL = !showImportURL",
          size="sm", variant="info") {{ showImportURL ? 'Скрыть импорт' : 'Импорт'}}
      b-button(@click="resetRoute", size="sm", variant="info") Сбросить
    div.d-flex.px-3.mb-2(v-if="showImportURL")
      b-form-input.flex-grow-1.mr-1(
        v-model="importURL",
        type="url",
        placeholder='Введите URL маршрута из Яндекса',
        size="sm", :style="{'font-size': '14px'}")
      b-button(@click="createImportedRoute", size="sm", variant="info") Импорт
    div.d-flex.justify-content-between.align-items-center.px-3.mb-2(v-if="route.length >= 2")
      div
        div Длина маршрута: {{ distance | distanceOutput }}
        div Время пути: {{ duration | durationOutput }}
      b-button(
        v-if="$route.name !== 'locator'",
        @click="toGeofencesPage",
        size="sm",
        variant="info", style="white-space: nowrap") Создать геозону
    div.d-flex.justify-content-between.align-items-center.px-3.mb-2(v-if="resolveSendObjectAlongRoute")
      date-picker.mr-2(v-model="routeObject.startTime")
      b-button(@click="sendObjectAlongRoute",
        :disabled="rejectSendObjectAlongRoute",
        size="sm",
        variant="info") Отправить объект по маршруту
  b-toast(id="objects-toast", variant="warning", solid, no-auto-hide)
    template(v-slot:toast-title)
      div.w-100.d-flex.justify-content-center.align-content-center
        strong.text-center {{ textToast }}
    b-progress(:max="maxValueLifeToast", :value="valueLifeToast" variant="warning")
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import draggable from 'vuedraggable';
import L from 'leaflet';
import { DateTime } from 'luxon';
import DatePicker from '@/components/DatePicker';
import LeMainMarker from './Marker';
// import imageGenerator from '~/plugins/handlers/imageGenerator';
// import {locale} from "devextreme/localization";

export default {
  name: 'LeMainObjects',
  components: {
    'l-marker-cluster': Vue2LeafletMarkercluster,
    'vue-custom-scrollbar': vueCustomScrollbar,
    'le-marker': LeMainMarker,
    draggable,
    DatePicker,
  },
  filters: {
    distanceOutput (value) {
      if (value < 1000) {
        return `${value} м`;
        // return value + this.$t('tracks.m'); // todo спросить
        // return $t('tracks.m');
      }
      return `${(value / 1000).toFixed(2)} км`;
      // return (value / 1000).toFixed(2) + this.$t('tracks.km'); // todo спросить
      // return $t('tracks.km');
    },
    durationOutput (value) {
      // console.debug(DateTime.now().plus(value * 1000).setLocale('ru').toRelative());
      // console.debug(DateTime.fromSeconds(value).setLocale('ru').toRelative());
      const res = DateTime.now().plus(value * 1000).setLocale('ru').toRelative();
      return res.replace('через', ''); // todo спросить
    },
  },
  data () {
    return {
      searchAU: '',
      resolveSetMarkers: false,
      layerForRoute: null,
      map: null,
      boundSetMarkersFunc: null,
      polyline: null,
      points: [
        {
          id: 0,
          address: null,
        },
        {
          id: 1,
          address: null,
        },
      ],
      idForNewPoint: 1,
      dragging: false,
      showImportURL: false,
      importURL: '',
      intervalProgressbar: null,
      maxValueLifeToast: 100,
      valueLifeToast: 0,
      textToast: '',
      dateRoute: null,
      arrPointsForGeofence: [],
      geofence: {
        geometry: {
          type: 'MultiLineString',
          coordinates: [],
        },
      },
      groupIcon: 'data:image/png;base64,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',
      showClusters: true,
      options: {
        popup: {
          // maxHeight: 200,
          autoPan: false,
          minWidth: 240,
          className: 'mapobj-popup',
          closeButton: false,
          keepInView: true,
        },
        cluster: {
          maxClusterRadius: 50,
          zoomToBoundsOnClick: true,
          // removeOutsideVisibleBounds: false,
          iconCreateFunction: (cluster) => {
            const all = cluster.getChildCount();
            return this.$L.divIcon({
              html: `<img src="${this.groupIcon}"/><div class="l-icon-cluster-img_num">${all}</div>`,
              className: 'l-icon-cluster-img',
              iconSize: this.dynamicSize,
              iconUrl: this.groupIcon,
              iconId: 'icon-object',
            });
          },
        },
        scroll: {
          minScrollbarLength: 60,
        },
      },
      currentSpider: null,
      popupCluster: [],
      timeout: null,
      settings: {
        map: false,
        // route: false,
        gsm: false,
        gps: false,
      },
      showGsmOpen: false,
      showGpsOpen: false,
      showRouteOpen: false,
      gsm: {
        timeFrom: '00:00:00',
        timeTo: '00:00:00',
        from: new Date(new Date().setDate(new Date().getDate() - new Date().getDay() - 6)),
        to: new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 1)),
        timeSendFrom: 16,
        timeSendTo: 600,
        monitoringOnly: false,
        radius: 5,
        blur: 15,
        accountingUnitId: null,
      },
      gps: {
        timeFrom: '00:00:00',
        timeTo: '00:00:00',
        from: new Date(),
        to: new Date(new Date().setDate(new Date().getDate() + 1)),
        minSatellites: 5,
        monitoringOnly: false,
        radius: 5,
        blur: 15,
        accountingUnitId: null,
      },
      route: [],
      distance: 0,
      duration: 0,
      seriesColors: ['#1f77b4', '#aec7e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896', '#9467bd', '#c5b0d5', '#8c564b', '#c49c94', '#e377c2', '#f7b6d2', '#7f7f7f', '#c7c7c7', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5'],
      // locale: this.settingsAUnit.language,
      selectedMap: 1,
      visibleTrackIcons: false,
      createGeofencesFromRoute: false,
      routeObject: {
        imei: '',
        startTime: new Date(),
        route: [],
      },
      pickerOptions: {
        firstDayOfWeek: 1,
      },
      finishSendObjectAlongRoute: true,
    };
  },
  computed: {
    ...mapState('tracks', ['activeTrackReport', 'v']),
    ...mapGetters('user', ['requireNewSession']),
    ...mapGetters('objects', ['mapReadyItems', 'arrItems', 'nameActiveObject', 'imeiActiveObject']),
    ...mapGetters('preferences', ['settingsAUnit', 'settingsMap']),
    ...mapGetters('tracks', ['arrItems', 'visibleTracks']),
    ...mapGetters('aUnits', { accountingUnits: 'accountingUnits' }),
    ...mapState('map', ['resolveAddMarkers', 'baseLayers']),
    // locale () {
    //   return this.accountingUnits.language;
    // },
    nameAUMap () {
      const accountingUnitIdMap = this.$store.state.user.data.isAdmin && this.$store.state.preferences.AUMap !== null ? this.$store.state.preferences.AUMap : this.$store.state.user.data.AccountingUnitId;
      return this.accountingUnits.find(au => au.Id === accountingUnitIdMap).Name;
    },
    nameSearchAU () {
      return this.searchAU.trim().toLowerCase();
    },
    availableAU () {
      const AU = this.accountingUnits;
      if (this.nameSearchAU) {
        return AU.filter(au => au.Name.toLowerCase().includes(this.nameSearchAU));
      }
      return AU;
    },
    dynamicSize () {
      const iconSize = (this.settingsAUnit.monitoringIconSize - 0.2) * 2.50 * 36;
      return [iconSize, iconSize];
    },
    rejectSendObjectAlongRoute () {
      return !this.routeObject.startTime || !this.finishSendObjectAlongRoute;
    },
    resolveSendObjectAlongRoute () {
      return this.activeObject && this.route.length >= 2;
    },
    grouping: {
      get () {
        return this.settingsMap.groupingObjects;
      },
      set (val) {
        this.setPreference({ groupingObjects: val });
      },
    },
    groupComponent () {
      return this.grouping ? 'l-marker-cluster' : 'l-layer-group';
    },
    activeObject: {
      set (val) {
        this.$store.commit('objects/setActiveObject', val);
      },
      get () {
        return this.$store.state.objects.activeObject;
      },
    },
    trackingIsActive () {
      return this.$store.state.objects.trackingIsActive;
    },
    activeItem () {
      return this.activeObject && this.trackingIsActive ? this.mapReadyItems.find(el => el.id === this.activeObject) : null;
    },
    withoutActive () {
      return this.activeObject && this.trackingIsActive ? this.mapReadyItems.filter(el => el.id !== this.activeObject) : this.mapReadyItems;
    },
    layers () {
      return this.baseLayers.map((_layer) => {
        const layer = _layer;
        return {
          text: layer.name,
          value: layer.id,
        };
      });
    },
    groupingRadius () {
      return this.settingsMap.groupingRadius;
    },
    ruLocale () {
      return {
        labelHours: 'Часы',
        labelMinutes: 'Минуты',
        labelSeconds: 'Секунды',
        labelIncrement: 'Увеличить',
        labelDecrement: 'Уменьшить',
        labelSelected: 'Выбранное время',
        labelNoTimeSelected: 'Время не выбрано',
        labelCloseButton: 'Закрыть',
      };
    },
  },
  watch: {
    async resolveAddMarkers (n) {
      if (n) {
        await this.$nextTick();
        this.$refs.cluster.mapObject.on('clustermouseover', (a) => {
          if (a.layer.getElement() !== this.currentSpider) {
            this.clustermouseover(a);
          }
        });
        this.$refs.cluster.mapObject.on('clustermouseout clusterclick', (a) => {
          if (a.layer.getElement() !== this.currentSpider) {
            this.popmouseout();
          }
        });
        this.$refs.cluster.mapObject.on('spiderfied', (a) => {
          this.spiderfied(a);
        });
        this.$refs.cluster.mapObject.on('unspiderfied', (a) => {
          this.unspiderfied(a);
        });
      }
    },
    $route (n) {
      if (n.name === 'geofences' && this.createGeofencesFromRoute) {
        this.showCreateGeofencesFromRoute();
        this.createGeofencesFromRoute = false;
      }
    },
    // eslint-disable-next-line func-names
    'settingsAUnit.monitoringIconSize': function (n) {
      this.$refs.cluster.mapObject.refreshClusters();
    },
    showRouteOpen (n) {
      if (n) {
        this.resolveSetMarkers = true;
        // eslint-disable-next-line
        this.map._container.__vue__.$el.classList.add('cursor-for-map');
        this.map.addEventListener('click', this.boundSetMarkersFunc);
        this.map.addLayer(this.layerForRoute);
      } else {
        this.resolveSetMarkers = false;
        // eslint-disable-next-line
        this.map._container.__vue__.$el.classList.remove('cursor-for-map');
        this.map.removeEventListener('click', this.boundSetMarkersFunc);
        this.map.removeLayer(this.layerForRoute);
      }
    },
    activeItem (n) {
      if (n) {
        global.mainMap.setView([n.reactive.lat, n.reactive.lng]);
      }
    },
    selectedMap (value) {
      if (value != null) {
        this.setPreference({ layerVisible: value });
        this.$store.dispatch('map/setSettingsLayerMap', this.selectedMap);
      }
    },
    v () {
      this.visibleTrackIcons = false;
      this.visibleTrackIcons = this.arrItems.length > 0;
    },
    groupingRadius (to) {
      this.options.cluster.maxClusterRadius = to;
      this.showClusters = false; // maxClusterRadius необновляемый параметр, чтобы он применился, необходимо удалить слой кластеризации и добавить обратно его с обновленными опциями
      this.$nextTick(() => { this.showClusters = true; });
    },
  },
  // async beforeCreate () {
  //   const img = await imageGenerator({ // prerender icon group
  //     file: '/img/car_icons.png',
  //     size: 50,
  //     offset: [100, 0],
  //   });
  //   this.groupIcon = img;
  // },
  created () {
    this.options.cluster.maxClusterRadius = this.groupingRadius;
  },
  mounted () {
    this.selectedMap = this.settingsMap.layerVisible;
    this.gsm.accountingUnitId = this.$store.state.user.data.AccountingUnitId;
    this.gps.accountingUnitId = this.$store.state.user.data.AccountingUnitId;
    this.map = global.mainMap;
    this.boundSetMarkersFunc = this.setMarker.bind(this.map);
    // eslint-disable-next-line
    this.layerForRoute = new L.layerGroup();
  },
  beforeDestroy () {
    this.restartObjectsToast();
  },
  methods: {
    ...mapActions('preferences', ['setPreference', 'setNoActivePreference']),
    async chooseAUMap (AU) {
      await this.$store.dispatch('map/getBaseLayers', AU.Id);
      await this.setPreference({ AUMap: AU.Id });
      const oldSelectedMap = this.baseLayers.find(layer => layer.id === this.selectedMap);
      if (!oldSelectedMap) {
        this.selectedMap = this.baseLayers[0].id;
      } else {
        await this.$store.dispatch('map/setSettingsLayerMap', this.settingsMap.layerVisible);
      }
      this.searchAU = '';
    },
    restartSendObjectAlongRoute () {
      this.routeObject.startTime = new Date();
      this.finishSendObjectAlongRoute = true;
    },
    async sendObjectAlongRoute () {
      this.finishSendObjectAlongRoute = false;
      this.routeObject.imei = this.imeiActiveObject;
      this.routeObject.route = this.route;
      this.routeObject.startTime = new Date(this.routeObject.startTime).toISOString();
      await this.$store.dispatch('objects/runObjectToRoute', this.routeObject);
      this.showObjectsToast(`Объект ${this.nameActiveObject} отправлен по маршруту`);
      this.restartSendObjectAlongRoute();
    },
    toGeofencesPage () {
      if (this.$route.name === 'geofences') {
        this.showCreateGeofencesFromRoute();
      } else {
        this.createGeofencesFromRoute = true;
        this.$router.push('/geofences/');
      }
    },
    showCreateGeofencesFromRoute () {
      if (this.polyline) {
        // eslint-disable-next-line
        this.geofence.geometry.coordinates = this.polyline._latlngs.map(objCoordinates => [objCoordinates.lng, objCoordinates.lat]);
      }
      this.geofence.geometry.type = 'LineString';
      this.$root.$emit('rootShowCreateGeofencesFromRoute', { dateRoute: this.dateRoute, points: this.points });
      this.$store.commit('geofences/setGeofencesJson', this.geofence.geometry);
    },
    transformationDateRoute () {
      this.dateRoute = new Date().toISOString();
      this.dateRoute = this.dateRoute.substring(0, this.dateRoute.lastIndexOf(':'));
      let currentHours = String(new Date().getHours());
      if (currentHours.length === 1) {
        currentHours = 0 + currentHours;
      }
      const startDate = this.dateRoute.slice(0, this.dateRoute.lastIndexOf('T') + 1);
      const endDate = this.dateRoute.slice(this.dateRoute.lastIndexOf(':'));
      this.dateRoute = startDate + currentHours + endDate;
    },
    restartObjectsToast () {
      if (this.intervalProgressbar) {
        clearInterval(this.intervalProgressbar);
      }
      this.valueLifeToast = this.maxValueLifeToast;
    },
    showObjectsToast (text) {
      this.restartObjectsToast();
      this.textToast = text;
      this.$bvToast.show('objects-toast');
      this.intervalProgressbar = setInterval(() => {
        this.valueLifeToast -= 1;
        if (this.valueLifeToast === 0) {
          this.$bvToast.hide('objects-toast');
          clearInterval(this.intervalProgressbar);
        }
      }, 25);
    },
    async createImportedRoute () {
      try {
        this.resolveSetMarkers = false;
        const arrSeparatedTextImportRoute = this.importURL.split('&');
        const extractedTextImportRoute = arrSeparatedTextImportRoute.find(item => item.includes('rtext='));
        const extractedСoordinatesImportRoute = extractedTextImportRoute.substring(extractedTextImportRoute.lastIndexOf('=') + 1);
        const arrPointsImportRoute = extractedСoordinatesImportRoute.split('~');

        this.layerForRoute.clearLayers();
        this.points = [];
        this.idForNewPoint = 1;

        this.route = arrPointsImportRoute.map((item, index) => {
          const arrStr = item.split('%2C');
          // eslint-disable-next-line
          const arrNum = arrStr.map(_item => Number(_item));
          this.addPoint();
          this.createPoint(arrNum, arrNum, index);
          return arrNum.reverse();
        });
      } catch (e) {
        this.showObjectsToast('Неверный адрес!');
      }
      await this.sendRoute();
      this.map.fitBounds(this.polyline.getBounds());
      this.showImportURL = false;
      this.resolveSetMarkers = true;
    },
    changeIcon () {
      const pointsWithAddress = this.points.filter((item, _index) => item.address || item.address === undefined);
      pointsWithAddress.forEach((item, index) => {
        // закомиченые условия ниже будут работать только при (this.route.length === this.points.length || this.points.length === pointsWithAddress.length)
        // eslint-disable-next-line
        // if (index > firstIndexEmptyPoint && this.layerForRoute.hasLayer(this.layerForRoute._layers[item.id])) { // условие при установки нового маркера (setMarker) todo объединить оптимизацию!
        // eslint-disable-next-line
        // if (index >= currentIndex && this.layerForRoute.hasLayer(this.layerForRoute._layers[item.id])) { // условие при удалении маркера (removePoint)
        // eslint-disable-next-line
        // if (index >= min && index <= max && this.layerForRoute.hasLayer(this.layerForRoute._layers[item.id])) { // условие при изменение порядка маркеров (checkMove)
        // eslint-disable-next-line
        if (this.layerForRoute.hasLayer(this.layerForRoute._layers[item.id])) {
          // eslint-disable-next-line
          this.layerForRoute._layers[item.id].setIcon(new L.divIcon({
            html: '<div class="route-marker">' +
              '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
              '\t width="48.213px" height="48.212px" viewBox="0 0 485.213 485.212" style="enable-background:new 0 0 485.213 485.212;"\n' +
              '\t xml:space="preserve">\n' +
              '<g>\n' +
              `\t<path fill=${this.seriesColors[index]} d="M242.606,0C142.124,0,60.651,81.473,60.651,181.955s151.631,303.257,181.956,303.257\n` +
              '\t\tc30.326,0,181.955-202.775,181.955-303.257S343.089,0,242.606,0z M242.606,303.257c-66.9,0-121.302-54.433-121.302-121.302\n' +
              '\t\tS175.706,60.651,242.606,60.651c66.902,0,121.302,54.435,121.302,121.304S309.509,303.257,242.606,303.257z"/>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '<g>\n' +
              '</g>\n' +
              '</svg>' +
              `<div class="l-icon-cluster-img_num">${index + 1}</div>` +
              '</div>',
            className: 'l-icon-cluster-img',
            iconSize: this.$L.point(36, 36),
            iconAnchor: [18, 42],
          }));
        }
      });
      return pointsWithAddress;
    },
    async sendRoute () {
      const stringLatLngPoints = this.route.join(';');
      if (this.polyline) {
        this.layerForRoute.removeLayer(this.polyline);
        this.polyline = null;
      }
      if (this.route.length >= 2) {
        const response = await this.$http.$get(`${process.env.OSRM_ADDRESS}/route/v1/car/${stringLatLngPoints}?generate_hints=false&overview=false&steps=true&geometries=geojson`).catch((error) => { // todo спросить про префикс
          this.$store.commit('notify/addNotify', {
            massage: `Ошибка ${error.name}: Ошибка получения информации о маршруте`,
            type: 'danger',
          }, { root: true });
        });
        // eslint-disable-next-line no-unreachable
        this.distance = response.routes[0].distance;
        this.duration = response.routes[0].duration;
        const arrPointsForRoute = [];
        response.routes[0].legs.forEach((item1) => {
          item1.steps.forEach((item2) => {
            item2.geometry.coordinates.forEach((item3) => {
              const arr = item3;
              arrPointsForRoute.push(arr.reverse());
            });
          });
        });
        // eslint-disable-next-line
        this.polyline = new L.polyline(arrPointsForRoute, { color: 'red' });
        this.layerForRoute.addLayer(this.polyline);
        this.transformationDateRoute();
      }
    },
    async createPoint (e, arrLatLngPoint, currentIndex = null) {
      let firstIndexEmptyPoint;
      let point;
      if (e.latlng) {
        firstIndexEmptyPoint = this.points.findIndex(item => item.address === null);
        // eslint-disable-next-line new-cap
        point = new L.marker(e.latlng, { draggable: true });
      } else {
        firstIndexEmptyPoint = currentIndex;
        // eslint-disable-next-line new-cap
        point = new L.marker(arrLatLngPoint, { draggable: true });
      }
      // eslint-disable-next-line
      const myIcon = new L.divIcon({
        html: '<div class="route-marker">' +
          '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
          '\t width="48.213px" height="48.212px" viewBox="0 0 485.213 485.212" style="enable-background:new 0 0 485.213 485.212;"\n' +
          '\t xml:space="preserve">\n' +
          '<g>\n' +
          `\t<path fill=${firstIndexEmptyPoint === -1 ? this.seriesColors[this.route.length] : this.seriesColors[firstIndexEmptyPoint]} d="M242.606,0C142.124,0,60.651,81.473,60.651,181.955s151.631,303.257,181.956,303.257\n` +
          '\t\tc30.326,0,181.955-202.775,181.955-303.257S343.089,0,242.606,0z M242.606,303.257c-66.9,0-121.302-54.433-121.302-121.302\n' +
          '\t\tS175.706,60.651,242.606,60.651c66.902,0,121.302,54.435,121.302,121.304S309.509,303.257,242.606,303.257z"/>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '<g>\n' +
          '</g>\n' +
          '</svg>' +
          `<div class="l-icon-cluster-img_num">${firstIndexEmptyPoint === -1 ? this.route.length + 1 : firstIndexEmptyPoint + 1}</div>` +
          '</div>',
        className: 'l-icon-cluster-img',
        iconSize: this.$L.point(36, 36),
        iconAnchor: [18, 42],
      });

      point.setIcon(myIcon);
      point.on('dragend', async (_e) => {
        this.resolveSetMarkers = false;
        // eslint-disable-next-line
        const arrLatLngPointDragend = Object.values(_e.target._latlng);
        const addressDragend = await this.$store.dispatch('nominatim/getAddress', { lat: arrLatLngPointDragend[0], lon: arrLatLngPointDragend[1], cacheOn: false }, { root: true });
        // eslint-disable-next-line
        const indexCurrentPoint = this.points.findIndex(item => item.id === _e.target._leaflet_id);
        this.points[indexCurrentPoint].address = addressDragend.original;
        const pointsWithAddress = this.points.filter((item, _index) => item.address || item.address === undefined);
        // eslint-disable-next-line
        const indexCurrentPointWithAddress = pointsWithAddress.findIndex(item => item.id === _e.target._leaflet_id);
        this.route.splice(indexCurrentPointWithAddress, 1, arrLatLngPointDragend.reverse());
        await this.sendRoute();
        this.resolveSetMarkers = true;
      });

      this.layerForRoute.addLayer(point);
      this.resolveSetMarkers = false;
      const address = await this.$store.dispatch('nominatim/getAddress', { lat: arrLatLngPoint[0], lon: arrLatLngPoint[1], cacheOn: false }, { root: true });
      // eslint-disable-next-line
      this.points[firstIndexEmptyPoint].id = point._leaflet_id;
      this.points[firstIndexEmptyPoint].address = address.original;
      this.resolveSetMarkers = true;

      return {
        firstIndexEmptyPoint,
        arrLatLngPoint,
      };
    },
    async setMarker (e) {
      if (this.resolveSetMarkers) {
        this.resolveSetMarkers = false;
        const arrLatLngPoint = Object.values(e.latlng);
        if (this.route.length < this.points.length && e.latlng) {
          const objPoint = await this.createPoint(e, arrLatLngPoint);
          this.route.splice(objPoint.firstIndexEmptyPoint, 0, objPoint.arrLatLngPoint.reverse());

          if (objPoint.firstIndexEmptyPoint < this.points.length - 1) {
            this.changeIcon();
          }

          await this.sendRoute();
          // eslint-disable-next-line
        } else if (this.route.length === this.points.length && this.layerForRoute.hasLayer(this.layerForRoute._layers[this.points[this.points.length - 1].id]) && e.latlng) {
          // eslint-disable-next-line
          this.layerForRoute._layers[this.points[this.points.length - 1].id].setLatLng(e.latlng);
          const address = await this.$store.dispatch('nominatim/getAddress', { lat: arrLatLngPoint[0], lon: arrLatLngPoint[1], cacheOn: false }, { root: true });
          this.route.splice(this.route.length - 1, 1, arrLatLngPoint.reverse());
          this.points[this.points.length - 1].address = address.original;
          await this.sendRoute();
        }
        this.resolveSetMarkers = true;
      }
    },
    resetRoute () {
      this.layerForRoute.clearLayers();
      this.polyline = null;
      this.points = [
        {
          id: 0,
          address: null,
        },
        {
          id: 1,
          address: null,
        },
      ];
      this.idForNewPoint = 1;
      this.route = [];
      this.distance = 0;
      this.duration = 0;
      this.importURL = '';
    },
    addPoint () {
      if (this.points.length < 20) {
        this.idForNewPoint += 1;
        this.points.push({ id: this.idForNewPoint, address: null });
      }
    },
    async removePoint (id, currentIndex) {
      this.resolveSetMarkers = false;
      // eslint-disable-next-line
      if (this.layerForRoute.hasLayer(this.layerForRoute._layers[id])) {
        // eslint-disable-next-line
        this.layerForRoute.removeLayer(this.layerForRoute._layers[id]);
      }
      this.points.splice(currentIndex, 1);
      const pointsWithAddress = this.changeIcon();
      // eslint-disable-next-line
      this.route = pointsWithAddress.map(item => Object.values(this.layerForRoute._layers[item.id]._latlng).reverse());
      await this.sendRoute();
      this.resolveSetMarkers = true;
    },
    checkMouseClick (e) {
      e.target.style.cursor = 'grab';
    },
    checkMouseOver (e) {
      e.target.style.cursor = 'grab';
    },
    checkMouseDown (e) {
      e.target.style.cursor = 'grabbing';
    },
    checkMouseUp (e) {
      e.target.style.cursor = 'grab';
    },
    async checkMove (e) {
      if (e.moved.element.address || e.moved.element.address === undefined) {
        this.resolveSetMarkers = false;
        const pointsWithAddress = this.changeIcon();
        // eslint-disable-next-line
        this.route = pointsWithAddress.map(item => Object.values(this.layerForRoute._layers[item.id]._latlng).reverse());
        await this.sendRoute();
        this.resolveSetMarkers = true;
      }
    },
    changeGrouping () {
      this.grouping = !this.grouping;
    },
    clearPopoutTimeout () {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    spiderfied (_a) {
      clearTimeout(this.timeout);
      this.currentSpider = _a.cluster.getElement();
    },
    unspiderfied (_a) {
      clearTimeout(this.timeout);
      this.currentSpider = null;
    },
    clustermouseover (a) {
      this.clearPopoutTimeout();

      if (this.popupCluster.length) {
        this.$refs.popup.mapObject.closePopup();
        this.popupCluster = [];
      }

      this.timeout = setTimeout(() => {
        this.$refs.popup.mapObject.openPopup(a.latlng);
        this.$nextTick().then(() => {
          this.popupCluster = a.layer.getAllChildMarkers().map(el => el.options.item);
        });
      }, this.settingsAUnit.timeoutPopupCluster * 1000);
    },
    popmouseover () {
      this.clearPopoutTimeout();
    },
    popmouseout () {
      this.clearPopoutTimeout();

      if (this.popupCluster.length === 0) {
        this.$refs.popup.mapObject.closePopup();
      } else {
        this.timeout = setTimeout(() => {
          this.$refs.popup.mapObject.closePopup();
          this.popupCluster = [];
        }, 1500);
      }
    },
    selectObject (val) {
      this.activeObject = val;
    },
    nameAU (value) {
      const item = this.accountingUnits.find(x => x.Id === value);
      return item ? item.Name : null;
    },
    getGSM (gsm) {
      this.settings.gsm = true;
      const from = new Date(gsm.from);
      const to = new Date(gsm.to);
      const timeFrom = gsm.timeFrom.split(':', 3);
      const timeTo = gsm.timeTo.split(':', 3);
      const params = {
        from: new Date(from.getFullYear(), from.getMonth(), from.getDate(), timeFrom[0], timeFrom[1], timeFrom[2], 0),
        to: new Date(to.getFullYear(), to.getMonth(), to.getDate(), timeTo[0], timeTo[1], timeTo[2], 0),
        secondsFrom: gsm.timeSendFrom,
        secondsTo: gsm.timeSendTo,
      };
      if (gsm.monitoringOnly) {
        params.objectIds = this.arrItems.map(x => x.id);
        params.accountingUnitId = gsm.accountingUnitId;
      } else {
        params.accountingUnitId = gsm.accountingUnitId;
      }
      this.$store.dispatch('heatmap/getGsm', { gsm: params, settings: { blur: Number(gsm.blur), radius: Number(gsm.radius) } });
      this.$root.$emit('bv::hide::popover', 'popover-create-gsm');
      this.showGsmOpen = false;
    },

    getGPS (gps) {
      this.settings.gps = true;
      const from = new Date(gps.from);
      const to = new Date(gps.to);
      const timeFrom = gps.timeFrom.split(':', 3);
      const timeTo = gps.timeTo.split(':', 3);
      const params = {
        from: new Date(from.getFullYear(), from.getMonth(), from.getDate(), timeFrom[0], timeFrom[1], timeFrom[2], 0),
        to: new Date(to.getFullYear(), to.getMonth(), to.getDate(), timeTo[0], timeTo[1], timeTo[2], 0),
        minSatellites: gps.minSatellites,
      };
      if (gps.monitoringOnly) {
        params.objectIds = this.arrItems.map(x => x.id);
        params.accountingUnitId = gps.accountingUnitId;
      } else {
        params.accountingUnitId = gps.accountingUnitId;
      }
      this.$store.dispatch('heatmap/getGps', { gps: params, settings: { blur: Number(gps.blur), radius: Number(gps.radius) } });
      this.$root.$emit('bv::hide::popover', 'popover-create-gps');
      this.showGpsOpen = false;
    },

    unVisibleHeatmap (gps) {
      this.$store.dispatch('heatmap/setVisible');
    },
    showGsm () {
      this.showGsmOpen = !this.showGsmOpen;
      this.showGpsOpen = false;
      this.showRouteOpen = false;
      this.settings.gsm = false;
      this.settings.gps = false;
      // this.settings.route = false;

      if (this.showGsmOpen) {
        this.unVisibleHeatmap();
      }
    },
    showGps () {
      this.showGpsOpen = !this.showGpsOpen;
      this.showGsmOpen = false;
      this.showRouteOpen = false;
      this.settings.gps = false;
      this.settings.gsm = false;
      // this.settings.route = false;

      if (this.showGpsOpen) {
        this.unVisibleHeatmap();
      }
    },
    showRoute () {
      this.showRouteOpen = !this.showRouteOpen;
      this.showGpsOpen = false;
      this.showGsmOpen = false;
      this.settings.gps = false;
      this.settings.gsm = false;
    },
  },
};
</script>

<style lang="stylus">
.dropdown-au-map > .dropdown-toggle {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#b-toaster-top-right {
  top: 50%;
}
#b-toaster-top-right > .b-toaster-slot {
  margin-right: auto;
}
.cursor-for-map {
  cursor: default;
}
.route-marker {
  & > div {
    min-height: auto;
    height 27px;
    width: 27px;
    top: 0px;
    right: 4.5px;
    font-size: 22px;
    font-weight: 700;
    border-radius: 100px;
  }
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group-item-field {
  display: flex;
  border: none;
}
.popover-panel {
  min-width: 500px;
}
.l-icon-cluster {
  content: '';
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #00a9bdcc;
  border: 2px solid rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  box-sizing: border-box;
}
.l-icon-cluster-img {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  img {
    width: 100%;
    height: auto;
  }
  &_num {
    position: absolute;
    top: -3px;
    right: -6px;
    padding: 3px;
    line-height: 1;
    border-radius: 25px;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0d0d0d;
    font-size: 11px;
    min-width: 10px;
    height: 10px;
  }
}
.mapobj-popup {
  margin-bottom: 40px;
  &--body {
    overflow: auto;
    display: flex;
    height: 100%;
    width: 100%;
    padding: 2px 0;
    section {
      min-width: 100%;
    }
  }
  .leaflet-popup {
    &-tip {
      display: none;
      &-container {
        left: calc(50% - 12px);
        bottom: calc(-.4rem - 1px);
        position:absolute;
        display:block;
        width:1rem;
        height:.5rem;
        margin:0 .3rem
        &:after,
        &:before {
          position:absolute;
          display:block;
          content:"";
          border-color:transparent;
          border-style:solid
        }
        &:before {
          bottom: 0;
          border-width: .5rem .5rem 0;
          border-top-color:
          rgba(0,0,0,.25);
        }
        &:after {
          bottom: 1px;
          border-width: .5rem .5rem 0;
          border-top-color: #fff;
        }
      }
    }
    &-content {
      margin: 0;
      color: #212529;
      &-wrapper {
        display: flex;
        max-width: 276px;
        max-height: 276px;
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
        font-style: normal;
        font-weight: 400;
        line-height: 1.5;
        text-align: left;
        text-decoration: none;
        text-shadow: none;
        text-transform: none;
        letter-spacing: normal;
        word-break: normal;
        word-spacing: normal;
        white-space: normal;
        line-break: auto;
        font-size: .875rem;
        word-wrap: break-word;
        background-clip: padding-box;
        border: 1px solid rgba(0,0,0,.2);
        border-radius: .3rem;
        box-shadow: none;
      }
    }
  }
}
.settings-map {
  .splank {
    border-radius: 3px;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.15);
    padding: 0 5px 0 0;

    .text-secondary {
      color: #b2b2b2 !important;
    }
  }
  .btn {
    border: 0px solid transparent;
    width: 36px;
    height: 36px;
  }
}
.base-layers-map {
  font-size: 11px !important;
  font-weight: normal !important;
  font-family: "Roboto", sans-serif !important;
  .col-form-label {
    color: #75767d !important;
  }
  .popover-body {
    text-decoration: none;
  }
  .form-check-input {
    margin-top: 0;
  }
}
.outmax {
  max-height: calc(100vh - 450px) !important;
}
</style>
<style lang="stylus" scoped>
.select-au-map {
  max-height: 200px;
  max-width: 350px;
  overflow-y: auto;
}
</style>
